<template>
  <b-nav-item v-if="isVisible" :to="{ name: 'ManageBDX' }">
    <b-icon-exclamation-triangle
      class="text-danger"
    ></b-icon-exclamation-triangle>
  </b-nav-item>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { useNewBDXItems } from '@composables/useNewBDXItems'

export default defineComponent({
  name: 'NewBDXIconNavItem',
  setup() {
    const { companyId, isVisible, hasNewBDXItems } = useNewBDXItems()

    return {
      companyId,

      isVisible,

      hasNewBDXItems
    }
  }
})
</script>
